import React from 'react';
import { Book, Check, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
const tomos = [{
  title: 'TOMO 1 — El Despertar de la Escucha',
  age: '0-6 meses',
  subtitle: 'Todo gran lenguaje empieza mucho antes de la primera palabra.',
  desc: 'Aprendé a estimular el contacto visual, la atención compartida, la respuesta al nombre y los primeros sonidos con actividades simples para los primeros 6 meses.'
}, {
  title: 'TOMO 2 — Del Balbuceo a la Intención',
  age: '6-12 meses',
  subtitle: 'Cuando los sonidos empiezan a tener significado.',
  desc: 'Descubrí cómo transformar el balbuceo en intención comunicativa y acompañar el camino hacia las primeras palabras con el método VEO-DIGO-HAGO.'
}, {
  title: 'TOMO 3 — La Explosión de las Palabras',
  age: '12-18 meses',
  subtitle: 'El momento en que el vocabulario empieza a crecer todos los días.',
  desc: 'Actividades diseñadas para ampliar el vocabulario, favorecer las primeras combinaciones y aprovechar una de las etapas más importantes del desarrollo del lenguaje.'
}, {
  title: 'TOMO 4 — Conectando Ideas',
  age: '18-24 meses',
  subtitle: 'Las primeras frases cambian la forma de comunicarse.',
  desc: 'Ayudá a tu hijo a pasar de palabras sueltas a frases cada vez más completas mediante juegos y actividades adaptadas a esta etapa.'
}, {
  title: 'TOMO 5 — Pequeños Narradores',
  age: '24-36 meses',
  subtitle: 'Cuando hablar deja de ser decir palabras y empieza a ser conversar.',
  desc: 'Acompañá el desarrollo de conversaciones, preguntas, historias y un lenguaje cada vez más rico para esta etapa.'
}, {
  title: 'TOMO 6 — SOS Fuera de Casa',
  age: '0-36 meses',
  subtitle: '50 actividades para reemplazar las pantallas en cualquier situación.',
  desc: 'Ideas listas para usar en el auto, el médico, el supermercado, un restaurante o cualquier salida. Sin materiales. Solo tu voz y tu presencia.'
}];
const comparison = [{
  feature: 'Organizado por etapas del desarrollo',
  ultrapack: true,
  internet: false
}, {
  feature: 'Actividades de 10 minutos o menos',
  ultrapack: true,
  internet: false
}, {
  feature: 'Sin materiales costosos',
  ultrapack: true,
  internet: false
}, {
  feature: 'Adaptado al contexto argentino',
  ultrapack: true,
  internet: false
}, {
  feature: 'Plan claro día a día',
  ultrapack: true,
  internet: false
}, {
  feature: 'Registro de hitos para el pediatra',
  ultrapack: true,
  internet: false
}, {
  feature: 'Anti-pantalla con alternativas reales',
  ultrapack: true,
  internet: false
}];
function scrollToCheckout() {
  document.getElementById('comprar')?.scrollIntoView({
    behavior: 'smooth'
  });
}
export function Product() {
  return <section className="py-12 px-5 bg-white" data-id="element-146">
      <div className="text-center mb-10" data-id="element-147">
        <h2 className="text-sm font-bold text-violet-600 uppercase tracking-widest mb-2" data-id="element-148">
          Presentamos el
        </h2>
        <h3 className="text-3xl font-extrabold text-gray-900 mb-4" data-id="element-149">
          Ultrapack Activador del Habla
        </h3>
        <p className="text-lg text-gray-600" data-id="element-150">
          El único sistema que te dice exactamente qué hacer en cada etapa para
          ayudar a tu hijo a desarrollar el habla desde casa.
        </p>
      </div>

      <div className="bg-violet-50 rounded-2xl p-6 mb-10 text-center border border-violet-100" data-id="element-151">
        <p className="font-bold text-violet-900 mb-2 text-[24px]" data-id="element-152">
          6 tomos con +300 actividades prácticas.
        </p>

        <p className="text-violet-800" data-id="element-153">
          Cada tomo fue diseñado para acompañar una etapa específica del
          desarrollo del lenguaje, para que siempre sepas qué hacer según la
          edad de tu hijo.
        </p>
      </div>

      <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-154">
        ¿Qué incluye el Ultrapack?
      </h4>

      <div className="space-y-6 mb-12" data-id="element-155">
        {tomos.map((tomo, index) => <Reveal key={index} delay={Math.min(index * 0.05, 0.25)} data-id="element-156">
            <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-100 transition-shadow hover:shadow-lg" data-id="element-157">
              <div className="flex items-center gap-3 mb-3" data-id="element-158">
                <div className="bg-violet-100 p-2 rounded-lg" data-id="element-159">
                  <Book className="w-6 h-6 text-violet-600" data-id="element-160" />
                </div>
                <div data-id="element-161">
                  <span className="text-xs font-bold text-violet-600 bg-violet-50 px-2 py-1 rounded-md" data-id="element-162">
                    {tomo.age}
                  </span>
                </div>
              </div>
              <h5 className="font-bold text-xl text-gray-900 mb-1" data-id="element-163">
                {tomo.title}
              </h5>
              <p className="text-sm font-medium text-violet-600 mb-3" data-id="element-164">
                {tomo.subtitle}
              </p>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-165">
                {tomo.desc}
              </p>
            </div>
          </Reveal>)}
      </div>

      <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-166">
        Lo que hace único al Ultrapack:
      </h4>

      <div className="overflow-hidden rounded-2xl border border-gray-200 shadow-sm mb-10" data-id="element-167">
        <table className="w-full text-left text-sm" data-id="element-168">
          <thead className="bg-gray-50" data-id="element-169">
            <tr data-id="element-170">
              <th className="p-4 font-bold text-gray-900 w-1/2" data-id="element-171">
                Característica
              </th>
              <th className="p-4 font-bold text-violet-700 text-center bg-violet-50" data-id="element-172">
                Ultrapack
              </th>
              <th className="p-4 font-bold text-gray-500 text-center" data-id="element-173">
                Internet
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100" data-id="element-174">
            {comparison.map((row, i) => <tr key={i} className="bg-white" data-id="element-175">
                <td className="p-4 text-gray-700 font-medium" data-id="element-176">{row.feature}</td>
                <td className="p-4 bg-violet-50/50 text-center" data-id="element-177">
                  <Check className="w-5 h-5 text-green-500 mx-auto" data-id="element-178" />
                </td>
                <td className="p-4 text-center" data-id="element-179">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-180" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <Button variant="green" onClick={scrollToCheckout} data-id="element-181">
        <span className="text-lg" data-id="element-182">✅ QUIERO EL ULTRAPACK AHORA</span>
      </Button>
      <p className="text-center text-sm text-gray-500 mt-3 font-medium" data-id="element-183">
        Acceso inmediato. Descarga instantánea.
      </p>
    </section>;
}